module.exports = __webpack_public_path__ + "static/media/Reddit.a73dc9ef.svg";